<template>
  <div class="menu-sidebar-container">
    <div
      class="overlay"
      v-if="isOpen"
      @click="closeSidebar"
    ></div>

    <div
      class="menu-sidebar"
      :class="{ 'is-open': isOpen }"
    >
      <div class="sidebar-header">
        <h2 class="sidebar-title">Menu</h2>
        <button class="close-btn" @click="closeSidebar">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <nav class="sidebar-nav">
        <router-link to="/" class="nav-link" @click="closeSidebar">{{ $t('home') || 'Home' }}</router-link>
        <router-link to="/produits" class="nav-link" @click="closeSidebar">{{ $t('catalogue') || 'Catalogue' }}</router-link>
        <!--router-link to="/blog" class="nav-link" @click="closeSidebar">{{ $t('blog') || 'Blog' }}</router-link-->
        <router-link to="/history" class="nav-link" @click="closeSidebar">{{ $t('myOrders') || 'My Orders' }}</router-link>
        <router-link to="/cart" class="nav-link" @click="closeSidebar">{{ $t('cart') || 'Cart' }}</router-link>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps({
  isOpen: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close']);

const closeSidebar = () => {
  emit('close');
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
  z-index: 100;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

@keyframes fadeIn {
  to { opacity: 1; }
}

.menu-sidebar {
  position: fixed;
  top: 0;
  right: -300px;
  width: 300px;
  height: 100vh;
  background-color: var(--bg-main, #ffffff);
  box-shadow: -4px 0 15px rgba(0, 0, 0, 0.05);
  z-index: 6000;
  transition: right 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
}

html[dir="rtl"] .menu-sidebar {
  right: auto;
  left: -300px;
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.05);
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-sidebar.is-open {
  right: 0;
}

html[dir="rtl"] .menu-sidebar.is-open {
  right: auto;
  left: 0;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid var(--border, #e5e7eb);
}

.sidebar-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-dark, #121212);
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--gray, #9ca3af);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  transition: color 0.2s ease;
}

.close-btn:hover {
  color: var(--text-dark, #121212);
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
}

.nav-link {
  padding: 15px 20px;
  text-decoration: none;
  color: var(--text-dark, #121212);
  font-size: 1.1rem;
  font-weight: 500;
  transition: background-color 0.2s ease, padding-left 0.2s ease;
}

html[dir="rtl"] .nav-link {
  transition: background-color 0.2s ease, padding-right 0.2s ease;
}

.nav-link:hover {
  background-color: var(--surface, #f1f5f9);
  padding-left: 25px;
  color: var(--accent, #9e7b46);
}

html[dir="rtl"] .nav-link:hover {
  padding-left: 20px;
  padding-right: 25px;
}
</style>